module.exports = __webpack_public_path__ + "2c318ee7ac43d590ca9badebfa32e660.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-iyaiya.png
// module id = 2030
// module chunks = 4